import { render } from "./UserStats.vue?vue&type=template&id=e715d3ee&scoped=true"
import script from "./UserStats.vue?vue&type=script&lang=js"
export * from "./UserStats.vue?vue&type=script&lang=js"

import "./UserStats.vue?vue&type=style&index=0&id=e715d3ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e715d3ee"]])

export default __exports__